import { detailModalConfig } from './modal-config';

const constant = {
  detailModalConfig
};

export default constant;
